import React, { FC, forwardRef } from 'react';
import { Value } from '@form/business/form.types';
import { AdvancedSelect, AdvancedSelectProps } from '@form/components/AdvancedSelect/AdvancedSelect.component';

type Props = Omit<AdvancedSelectProps, 'multiple' | 'onSelect'> & {
  onSelect: (value?: Value) => void;
};

export const SimpleSelect: FC<Props> = forwardRef(({ onSelect, ...rest }, simpleSelectRef) => {
  const rootOnSelect = (selection?: Value | Value[]) => {
    if (!selection) {
      onSelect(undefined);
    } else {
      onSelect(Array.isArray(selection) ? selection[0] : selection);
    }
  };
  return <AdvancedSelect onSelect={rootOnSelect} ref={simpleSelectRef} {...rest} />;
});
